import router from '@/router'
import { UserServices } from '@/services/user.services'
import { JabberService } from '@/services/jabber.service'

const state = {
  loading: false,
  dialogjabber: false,
  dialogverifikasihp: false,
  dialog: false,
  overlay: false,
  kodepromo: [],
  totalkodepromo: 0,
  balance: 0,
  jabberlist: [],
  totaljabber: 0,
  qr2fa: '',
  usertrx: {
    ip: '',
    apikey: '',
    callback: ''
  }
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setdialogverifyhp ({ commit }, diag) {
    commit('setdialogverifyhp', diag)
  },
  setdialogjabber ({ commit }, diag) {
    commit('setdialogjabber', diag)
  },
  updateNewProfile ({ dispatch, commit }, data) {
    commit('setloading', true)
    UserServices.verifyProvile(data)
      .then(data => {
        console.log(data)
        commit('setloading', false)
        dispatch('alert/success', 'update OK!', { root: true })
        dispatch('authentication/getme', {}, { root: true })
      }).catch(error => {
        commit('setloading', false)
        dispatch('alert/error', error, { root: true })
      })
  },
  updateProfile ({ dispatch, commit }, data) {
    commit('setloading', true)
    UserServices.updateProvile(data)
      .then(data => {
        console.log(data)
        commit('setloading', false)
        dispatch('alert/success', 'update OK!', { root: true })
      }).catch(error => {
        commit('setloading', false)
        dispatch('alert/error', error, { root: true })
      })
  },
  gantipassword ({ dispatch, commit }, { pass }) {
    commit('setloading', true)
    UserServices.gantipassword(pass)
      .then(data => {
        console.log(data)
        commit('setloading', false)
        router.push('/login')
        dispatch('alert/success', 'Ganti Password Successfully', { root: true })
      }).catch(error => {
        commit('setloading', false)
        dispatch('alert/error', error, { root: true })
      })
  },
  getBalance ({ commit }) {
    commit('setloading', true)
    UserServices.getBalance().then(value => {
      commit('setloading', false)
      commit('setbalance', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getIP ({ commit }) {
    commit('setloading', true)
    UserServices.getIPAPI().then(value => {
      commit('setloading', false)
      commit('setdataip', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  resetAPI ({ dispatch, commit }) {
    commit('setloading', true)
    UserServices.resetAPIKey().then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  verifyPhone ({ dispatch, commit }, data) {
    commit('setloading', true)
    UserServices.verifyPhone(data).then(value => {
      commit('setloading', false)
      commit('setdialogverifyhp', false)
      dispatch('alert/success', value.msg, { root: true })
      dispatch('authentication/getme', {}, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  setAPI ({ dispatch, commit }, data) {
    commit('setloading', true)
    UserServices.setIP(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getJabberList ({ commit }, opt) {
    commit('setloading', true)
    JabberService.getAllJabber(opt).then(value => {
      commit('setloading', false)
      commit('setdatajabber', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  addJabber ({ dispatch, commit }, data) {
    commit('setloading', true)
    JabberService.addJabber(data).then(value => {
      commit('setloading', false)
      commit('setdialogjabber', false)
      dispatch('alert/success', value.msg, { root: true })
      dispatch('getJabberList', {})
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  deletejabber ({ dispatch, commit }, id) {
    commit('setloading', true)
    JabberService.deleteJabber(id).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
      dispatch('getJabberList', {})
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getQr2fa ({ commit }) {
    commit('setloading', true)
    UserServices.generateQr2fa().then(value => {
      commit('setloading', false)
      commit('setqr2fa', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  verifyAct2fa ({ dispatch, commit }, data) {
    commit('setloading', true)
    UserServices.verifyAct2fa(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
      router.push('/login')
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  }
}
const mutations = {
  setqr2fa (state, s) {
    state.qr2fa = s.data
  },
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialogjabber (state, s) {
    state.dialogjabber = s
  },
  setdialogverifyhp (state, s) {
    state.dialogverifikasihp = s
  },
  setdata (state, s) {
    state.kodepromo = []
    state.kodepromo = s.data.content
    state.totalkodepromo = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdataip (state, s) {
    state.usertrx.ip = s.data.ip
    state.usertrx.apikey = s.data.apikey
    state.usertrx.callback = s.data.callback
    state.loading = false
    state.overlay = false
  },
  setbalance (state, s) {
    state.balance = s.data
  },
  setdatajabber (state, s) {
    state.jabberlist = []
    state.jabberlist = s.data.content
    state.totaljabber = s.data.totalElements
    state.loading = false
    state.overlay = false
  }
}

export const UserStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
